import {useState} from 'react';
import PropTypes from 'prop-types';

export default function LoginScreen({onLogin}) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    async function handleSubmit(e) {
        e.preventDefault();
        setError('');
        try {
            const res = await fetch('/auth/login', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({username, password}),
            });
            if (!res.ok) {
                setError('Invalid username or password');
                return;
            }
            const data = await res.json();
            onLogin(data.token, data.username, data.userID);
        } catch {
            setError('Login failed. Please try again.');
        }
    }

    return (
        <div className="login-screen">
            <form className="login-form" onSubmit={handleSubmit}>
                <h2 className="login-title">Sign in</h2>
                {error ? <p className="login-error">{error}</p> : null}
                <input
                    className="login-input"
                    type="text"
                    placeholder="Username"
                    value={username}
                    onChange={e => setUsername(e.target.value)}
                    autoFocus
                />
                <input
                    className="login-input"
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                />
                <button
                    className="login-button"
                    type="submit"
                    disabled={!username || !password}
                >Sign in</button>
                <p className="login-register-link">
                    New here? <a href="/?register">Create an account</a>
                </p>
            </form>
        </div>
    );
}

LoginScreen.propTypes = {
    onLogin: PropTypes.func.isRequired,
};
